export function numberLocaleString(number: number): string {
    if(isNaN(number) || number===null) return '-'
    return String(number.toLocaleString())
}